/* eslint-disable complexity */
import { useContext } from 'preact/hooks';
import PropTypes from 'prop-types';

import { noop } from '../../helpers/noop';

import Countdown from '../Countdown/Countdown.component';
import PollOptionsList from './pollOptionsList.component';
import PollTotalVotes from '../PollTotalVotes/pollTotalVotes.component';
import SubmitButton from '../shared-components/button/SubmitButton';
import SignInGate from '../shared-components/gate/SignInGate.component';

import { PollContext } from '../../potg/potg.component';

import styleSheet from './poll.module.scss';
import { useTranslation } from 'react-i18next';

const styles = styleSheet.locals || {};

/**
 * Component which allows fan to vote for an option
 *
 * @param {object} props poll option props
 * @param {string} props.transitionState transition state
 * @returns {Function} <PollVoteScreen />
 */
function PollVoteScreen({ transitionState }) {
    const {
        poll,
        selectedOptions,
        submittingVote = false,
        showVotesCounter = false,
        transitionStyles,
        transitionDelay,
        onVoteSubmit = noop,
        totalVotes = 0,
        onCountdownEnd,
        isSignedIn,
        isGated
    } = useContext(PollContext);
    const { t } = useTranslation();

    const isClosed = poll?.state === 'closed';

    const isDisabled = () => {
        if (isGated && !isSignedIn) {
            return true;
        }

        return selectedOptions.length === 0;
    };

    return (
        <div
            part="potg-vote"
            className={isGated ? styles.pollWrapperGated : styles.pollWrapper}
        >
            {!isSignedIn && isGated && (
                <SignInGate type={'poll'} isResults={isClosed} />
            )}
            <PollOptionsList />

            <div
                className={styles.pollSubmitContainer}
                style={{
                    ...transitionStyles[transitionState],
                    transitionDelay: `${transitionDelay}ms`
                }}
            >
                <SubmitButton
                    onSubmit={onVoteSubmit}
                    disabled={isDisabled()}
                    title={t('polling.submitTooltip')}
                    buttonText={t('polling.submit')}
                    loading={submittingVote}
                />
                {showVotesCounter && (
                    <PollTotalVotes
                        votes={totalVotes}
                        style={{
                            ...transitionStyles[transitionState]
                        }}
                    />
                )}
            </div>
            {poll.closes_at && (
                <Countdown
                    text={t('polling.closesIn')}
                    datetime={poll.closes_at}
                    onCountdownEnd={onCountdownEnd}
                    closes={true}
                />
            )}
        </div>
    );
}

PollVoteScreen.propTypes = {
    transitionState: PropTypes.string.isRequired
};

export default PollVoteScreen;
